import { forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

function timeStringToDate(hhmm) {
  if (!hhmm) return null
  const [hStr, mStr] = String(hhmm).trim().split(':')
  const h = parseInt(hStr, 10)
  const m = parseInt(mStr, 10)
  if (Number.isNaN(h) || Number.isNaN(m)) return null
  const date = new Date()
  date.setHours(h, m, 0, 0)
  return date
}

function dateToTimeString(date) {
  if (!date || Number.isNaN(date.getTime())) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const TimeInput = forwardRef(({ value, onClick, onChange, placeholder, required, disabled }, ref) => (
  <div className="due-time-input-group">
    <input
      ref={ref}
      type="text"
      className="form-control due-time-input"
      value={value}
      onClick={onClick}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      readOnly
      autoComplete="off"
    />
    <span className="due-time-input-icon" aria-hidden="true">
      <i className="fa-solid fa-clock" />
    </span>
  </div>
))

TimeInput.displayName = 'TimeInput'

export default function DueTimePicker({
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder = 'Select time'
}) {
  const selected = timeStringToDate(value)

  return (
    <DatePicker
      selected={selected}
      onChange={(date) => onChange(dateToTimeString(date))}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={1}
      timeCaption="Time"
      dateFormat="h:mm aa"
      placeholderText={placeholder}
      required={required}
      disabled={disabled}
      popperPlacement="bottom-start"
      popperClassName="due-time-picker-popper"
      calendarClassName="due-time-picker-calendar"
      customInput={<TimeInput placeholder={placeholder} required={required} disabled={disabled} />}
    />
  )
}
